import { useTranslation } from 'react-i18next';
import type { AppId, AppPlatform } from '../../api/types';

export const APP_VERSION_POLICY_KEY = ['admin', 'settings', 'app-version-policy'];

const IST_DATE_TIME = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Kolkata',
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** DD Mon YYYY, HH:mm in IST (UX principle 4). */
export function formatUpdatedAt(iso: string): string {
  return IST_DATE_TIME.format(new Date(iso));
}

/** The reader-facing names: `fleet` is the Partner app (R50). */
export function useAppLabels() {
  const { t } = useTranslation();
  const app = (id: AppId) =>
    id === 'driver' ? t('settings.appUpdates.appDriver') : id === 'shipper' ? t('settings.appUpdates.appShipper') : t('settings.appUpdates.appPartner');
  const platform = (id: AppPlatform) =>
    id === 'android' ? t('settings.appUpdates.platformAndroid') : t('settings.appUpdates.platformIos');
  return { app, platform };
}
